import { Country } from '../locales';
import { DateTimeFormat, getDateTimeFormatter } from './getDateTimeFormatter';

export const timeZones: { [key in Country]: string } = {
  [Country.SE]: 'Europe/Stockholm',
  [Country.FI]: 'Europe/Helsinki',
} as const;

export function useFormatDateTime(pattern: DateTimeFormat, country = Country.SE) {
  const format = getDateTimeFormatter(pattern, timeZones[country]);

  return (date: Date | string) => format(date);
}
